import styled from 'styled-components';
import {
  Notification as _Notification,
  FlexContainer as FlexContainer_,
} from '@taxdown/piccolo-web';
import ThreeColLayout_ from 'Components/Layouts/ThreeColLayout';
import { Lottie } from 'Components/UI';
import bgConfetti from 'Assets/images/confettiBg.png';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from 'Styles/variables/sizes';
import { stages } from 'Constants/stages';
import { TaxReturnTypes } from './types';

const STATUS_TYPES = {
  [stages.DISCARDED]: 'linear-gradient(180deg, #FFDFD8 0%, #FFCED7 100%)',
  [stages.MISSING_INFORMATION]: 'linear-gradient(180deg, #fff5dd 0%, #ffdfb9 100%)',
};

export const ThreeColLayout = styled(ThreeColLayout_)`
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    display: grid;
    grid-template-columns: 3fr;
    grid-column-gap: 30px;
    padding: 30px;
    height: 100%;
  }
`;

export const Container = styled(FlexContainer_)`
  background-image: ${({ theme: { colors }, type }) =>
    type === TaxReturnTypes.TO_RETURN
      ? `url(${bgConfetti}), ${colors.iridiscent_gradient}`
      : colors.iridiscent_gradient};
  border: 1px solid ${({ theme: { colors } }) => colors.blue_5};
  border-radius: 10px;
  height: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    padding: 20px;
  }
`;
export const TransitionContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  border-radius: 14px;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;

  background: ${({ isFull, stage }) =>
    STATUS_TYPES[stage]
      ? STATUS_TYPES[stage]
      : isFull
        ? 'linear-gradient(180deg, rgba(255, 199, 0, 0.03) 0%, rgba(255, 199, 0, 0.1) 100%)'
        : 'linear-gradient(180deg, #E0F7E9 43.45%, #99F3C3 100%)'};
`;

export const WizardBox = styled.div`
  background-color: ${({ theme: { colors } }) => colors.white};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 1rem;
  width: 100%;
  max-width: 450px;
  margin-top: 14px;
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-radius: 10px;
  width: 100%;
  margin: 0 auto;
  max-width: 450px;
`;

export const StyledLottie = styled(Lottie)`
  margin: 34px 0;
  max-width: 800px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    margin: 30px 0;
    height: 250px;
  }
`;

export const FlexContainer = styled(FlexContainer_)`
  width: 193px;
  height: 201px;
`;

export const TextsContainer = styled(FlexContainer_)`
  flex-wrap: wrap;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
`;

export const Notification = styled(_Notification)`
  width: 450px;
  margin: ${({ theme: { sizing } }) => sizing.fds_size_16};
  box-shadow: ${({ theme: { boxShadows } }) =>
    `${boxShadows.fds_elevation_500.x} ${boxShadows.fds_elevation_500.y} 4px ${boxShadows.fds_elevation_500.spread} ${boxShadows.fds_elevation_500.color}`};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: auto;
  }
`;

export const ButtonsContainer = styled(FlexContainer_)`
  display: flex;
  flex-direction: column;
  max-width: 300px;
`;
